import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import { TitleStrategy, provideRouter, withComponentInputBinding } from '@angular/router'

import { routes } from './app.routes'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { HttpClientModule, provideHttpClient } from '@angular/common/http'
import { TemplatePageTitleStrategy } from './template-page-title.strategy'
import { httpInterceptorProviders } from '@core/interceptors'
import { CookieService } from 'ngx-cookie-service'
import { provideAngularSvgIcon } from 'angular-svg-icon'

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    { provide: TitleStrategy, useClass: TemplatePageTitleStrategy },
    provideAngularSvgIcon(),
    provideAnimationsAsync(),
    provideHttpClient(),
    importProvidersFrom(HttpClientModule),
    httpInterceptorProviders,
    CookieService,
  ],
}
